import Toastr from "../../../itrust_common/components/Toastr"
const DEFAULT_STATE = {
  tags: [],
  tag: {},
  meta: { pagination: {} },
  saving: false
}
let changes = null;
export default function tagReducer(state = DEFAULT_STATE, action){
  const response = action.payload && (action.payload.data || action.payload.response)
  let tags = [];
  let tagData = [];
  let updatedRecord = {};
  switch(action.type){
    case 'TAGS_LOAD_PENDING':
    case 'TAG_LOAD_PENDING':
      return {...state, saving: true};

    case 'TAG_CREATE_PENDING':
      return {...state, saving: true};

    case 'TAGS_LOAD_REJECTED':
    case 'TAG_LOAD_REJECTED':
    case 'TAG_CREATE_REJECTED':
      Toastr.handleShow(response.data.success, response.data.error, response.data.status_code)
      changes = {
        saving: false
      }
      return {...state,...changes};

    case 'TAGS_LOAD_FULFILLED':
      changes = {
        ...response,
        saving: false
      };
      return {...state, ...changes};
    
    case 'TAG_LOAD_FULFILLED':
      changes = {
        tag: response.tag,
        saving: false
      }
      return {...state,...changes};
    
    case 'TAG_CREATE_FULFILLED':
      Toastr.handleShow(true, response.meta.message, 201)
      tags = [...state.tags]
      let newRecord = response.tag
      changes = {
        tags: [...tags, newRecord],
        saving: false
      }
      return {...state, ...changes};

    case 'TAG_UPDATE_FULFILLED':
      Toastr.handleShow(true, response.meta.message, 201)
      tags = [...state.tags];
      updatedRecord = response.tag;
      for (const [index, tag] of tags.entries()) {
        if (tag.id === updatedRecord.id) {
          tagData = [
            ...tags.slice(0, index),
            updatedRecord,
            ...tags.slice(index + 1)
          ];
        }
      }
      changes = {
        tags: tagData,
        editing: false,
        saving: false
      };
      return { ...state, ...changes };

    case 'TAG_DELETE_FULFILLED':
      Toastr.handleShow(true, response.meta.message, 201)
      tags = [...state.tags];
      for (const [index, tag] of tags.entries()) {
        if (tag.id === action.payload.id) {
          tags.splice(index, 1);
        }
      }
      return {
        ...state,
        tags: tags,
        error: null
      };

    case 'TAG_EDIT':
      changes = {
        editing: {
          id: action.id,
        },
        tag: {}
      };
      return { ...state, ...changes };

    case 'TAG_EDIT_CANCEL':
      changes = {
        editing: false
      };
      return { ...state, ...changes };

    default:
      return state;
  }
}